import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import SortSvg from "../assets/svg/SortSvg";


export default function UserBuyBanner({
  handleSearch,
  handleUnBatch,
  showUnbatchLoader,
  handleCreateBatch,
  showButtonLoader,
  htmlString,
  hideBatchStatus,
  handleBatchStatus,
  batchCount,
  bidStatus,
  handleViewBid,
  bidCount,
  askStatus,
  handleViewAsk,
  askCount,
  filterCount,
  handlefilterModal,
  selectCheckBox,
  handleSelectAll,
  handleSort,
  sortColumn,
  sortOrder,
}) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isFunctionMenuExpanded, setIsFunctionMenuExpanded] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const headerScrollRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Expose scroll ref for parent component
  useEffect(() => {
    if (headerScrollRef.current) {
      window.buySellHeaderScroll = headerScrollRef.current;
    }
  }, []);

  // Handle scroll to make function menu sticky
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsSticky(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="position-relative container" style={{ overflow: 'visible', minHeight: isMobile ? '160px' : '180px', height: isMobile ? '232px' : '213px' }}>
      <img
        className="w-100"
        src="/userbuysellbgimg.webp"
        width={1920}
        height={140}
        alt="Banner"
        style={{ 
          height: isMobile ? '232px' : '213px',
          objectFit: 'cover'
        }}
        // fetchpriority="high"
      />
      <Row className="buy-sell-part position-absolute top-0 start-0 w-100">
        <Col lg={12} md={12} xs={12} className="buy-sell-col-mobile">
          <div className="rounded buy-sell-container" style={{ backgroundColor: 'none' }}>
            <div 
              className="w-100" 
              style={{ 
                padding: isMobile ? '16px 16px' : '20px 24px',
                minHeight: isMobile ? 'auto' : 'auto',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'flex-start' : 'center',
                justifyContent: 'space-between',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                gap: isMobile ? '12px' : '20px'
              }}
            >
              <h1 
                className="mb-0 text-white fw-bold" 
                style={{ 
                  fontSize: isMobile ? '18px' : '24px',
                  lineHeight: '1.2',
                  margin: 0,
                  color: '#FFFFFF',
                  textAlign: 'left',
                  flexShrink: 0,
                  maxWidth: isMobile ? '100%' : '30%'
                }}
              >
                Buy & Sell GPUs (Order Book)
              </h1>
              <p
                className="mb-0 text-white"
                style={{
                  fontSize: isMobile ? '12px' : '14px',
                  lineHeight: '1.5',
                  margin: 0,
                  color: '#FFFFFF',
                  textAlign: 'left',
                  flex: isMobile ? '0 0 auto' : '1 1 auto',
                  maxWidth: isMobile ? '100%' : '70%',
                  padding: 0
                }}
              >
                Power-user order book for GPUs. See highest bids, lowest asks, your asks/bids, and spreads for every card in one table. Batch bids so you can bid on many GPUs while only buying one, sort by Deal Score to target the best price-to-performance deals.
              </p>
            </div>
            <div className="d-md-flex align-items-center justify-content-between" style={{ gap: isMobile ? '12px' : '20px', padding: isMobile ? '0' : '0 24px' }}>
            <div className="d-flex align-items-center search-box-wrapper" style={{ backgroundColor: 'transparent', maxWidth: isMobile ? '100%' : '30%', flexShrink: 0, padding: isMobile ? '16px 0' : '16px 0' }}>
              {/* <h4 className="mb-0 text-white me-md-3 me-2 fw-bold text-nowrap buy-sell-header">
                Buy/Sell
              </h4> */}
              <div className="position-relative search-input-wrapper flex-grow-1">
                <Form.Control
                  type="search"
                  placeholder="Search from GPUs below"
                  onChange={(e) => handleSearch(e.target.value)}
                  className="search-input-white"
                />
                <svg
                  className="search-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                    stroke="#999"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 14L11.1 11.1"
                    stroke="#999"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              {isMobile && (
                <Button
                  type="button"
                  className="function-menu-toggle-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsMobileMenuOpen(prev => !prev);
                  }}
                  onTouchStart={(e) => {
                    e.stopPropagation();
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsMobileMenuOpen(prev => !prev);
                  }}
                >
                  {isMobileMenuOpen ? '▼ Hide Functions' : '▲ Show Functions'}
                </Button>
              )}
            </div>
            <div className={`function-menu-sticky ${isMobile ? 'mobile' : ''} ${isSticky ? 'sticky-active' : ''} ${isFunctionMenuExpanded ? 'expanded' : ''}`} style={{ maxWidth: isMobile ? '100%' : '70%', flex: isMobile ? '0 0 auto' : '1 1 auto' }}>
              {!isMobile && isSticky && (
                <Button
                  className="function-menu-expand-btn"
                  onClick={() => setIsFunctionMenuExpanded(!isFunctionMenuExpanded)}
                >
                  {isFunctionMenuExpanded ? '▼' : '▲'}
                </Button>
              )}
              <div className={`function-menu-panel ${isMobile ? 'mobile' : ''} ${isMobile && !isMobileMenuOpen ? 'd-none' : ''} ${!isMobile && (isFunctionMenuExpanded || !isSticky) ? 'expanded' : ''}`}>
                <div className="d-flex align-items-center flex-wrap buttons-wrapper px-3 py-2" style={{ justifyContent: 'flex-end', padding: isMobile ? '16px 0' : '16px 0' }}>
                  <Button
                    className="btn-buy-sell text-capitalize"
                    onClick={handleCreateBatch}
                  >
                    {showButtonLoader ? "Please Wait..." : "Batch"}
                    <QuestionMarkSvg />
                  </Button>
                  <ReactTooltip
                    className="custom-tooltip_buy-sell"
                    anchorId="app-batch-buying-tab"
                    place="bottom"
                    clickable={true}
                    closeOnScroll={false}
                    content={
                      <div
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                      />
                    }
                    style={{ textTransform: "none" }}
                  />

                  <Button
                    className="btn-buy-sell text-capitalize"
                    onClick={handleUnBatch}
                  >
                    {showUnbatchLoader ? "Please Wait..." : "Unbatch"}
                  </Button>

                  <Button
                    className={`btn-buy-sell text-capitalize ${
                      hideBatchStatus ? "btn-buy-sell-active" : ""
                    }`}
                    onClick={handleBatchStatus}
                  >
                    {hideBatchStatus ? `Hide Batch (${batchCount || 0})` : `Show Batch (${batchCount || 0})`}
                  </Button>
                  <Button
                    className={`btn-buy-sell text-capitalize ${
                      askStatus ? "btn-buy-sell-active" : ""
                    }`}
                    onClick={handleViewAsk}
                  >
                    My Asks ({askCount})
                  </Button>
                  <Button
                    className={`btn-buy-sell text-capitalize ${
                      bidStatus ? "btn-buy-sell-active" : ""
                    }`}
                    onClick={handleViewBid}
                  >
                    My Bids ({bidCount})
                  </Button>

                  <Button
                    className="btn-buy-sell text-capitalize"
                    onClick={() => handlefilterModal()}
                  >
                    Filters ({filterCount})
                  </Button>
                </div>
              </div>
            </div>
          </div>
          </div>
        </Col>
        <Col lg={12} className="text-start"></Col>
      </Row>
      <div className="position-absolute bottom-0 start-0 w-100 buy-sell-table-header container">
        <div className="table-responsive" ref={headerScrollRef} style={{ overflowX: 'auto' }}>
          <Table className="align-middle graphic-table by-sell-table mb-0" style={{ width: '100%', tableLayout: 'auto' }}>
            <thead style={{ backgroundColor: 'unset !important' }}>
              <tr>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }}></th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }}>
                  <div className="text-start d-flex align-items-center gap-2">
                    <label className="text-white mb-0 buy-sell-label" style={{ alignItems: 'right' }}>Select All</label>
                    <Form.Check
                      className="d-inline buysellp"
                      type="checkbox"
                      checked={selectCheckBox}
                      onClick={(e) => handleSelectAll(e)}
                    />
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("dealScore")}>
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <ReactTooltip
                      className="custom-tooltip text-center"
                      anchorId="deal-score-tooltip"
                      place="bottom"
                      style={{ maxWidth: "240px" }}
                      clickable={true}
                      closeOnScroll={false}
                      content="Higher Deal Score means better value. It measures performance per dollar using the live price and the model's benchmark score."
                    />
                    <span id="deal-score-tooltip" className="d-flex align-items-center justify-content-center" style={{ cursor: "pointer", flexShrink: 0, color: "white" }}>
                      <QuestionMarkSvg />
                    </span>
                    <span className="text-white buy-sell-label">Deal Score</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="dealScore" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("brand")}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Brand</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="brand" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("series")}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Series</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="series" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("model")}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Model</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="model" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("highest_bid")}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Highest Bid</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="highest_bid" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }} onClick={() => handleSort("lowest_ask")}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Lowest Ask</span>
                    <span className="text-white">
                      <SortSvg sortColumn={sortColumn} sortOrder={sortOrder} currentColumn="lowest_ask" />
                    </span>
                  </div>
                </th>
                <th className="buy-sell-th" style={{ backgroundColor: 'transparent' }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <span className="text-white buy-sell-label">Your Ask/Bid</span>
                  </div>
                </th>
              </tr>
            </thead>
          </Table>
        </div>
      </div>
    </div>
  );
}